import { render } from "./AlertContactDetails.vue?vue&type=template&id=6f3c1926"
import script from "./AlertContactDetails.vue?vue&type=script&lang=js"
export * from "./AlertContactDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__